import React from "react";
import "./styles.css";

export const Button = ({
  variant = "default",
  size = "default-size",
  className = "",
  ...props
}) => {
  return (
    <button
      className={`custom-signal-com-required-btn custom-signal-com-required-btn-${variant} custom-signal-com-required-btn-${size} ${className}`}
      {...props}
    />
  );
};